/**
 * Shopify Chat Scroll Behavior
 * Controls chat bubble visibility on product pages based on scroll depth
 * Shows chat after 1200px scroll, hides when scrolling back above threshold
 */

(function() {
  'use strict';

  const SCROLL_THRESHOLD = 1200; // pixels
  const HIDDEN_CLASS = 'shopify-chat-scroll--hidden';
  const VISIBLE_CLASS = 'shopify-chat-scroll--visible';

  function init() {
    // Check if this is a product page
    const isProductPage = document.body.getAttribute('data-is-product-page') === 'true';
    
    if (!isProductPage) {
      return; // Exit early if not a product page
    }

    // Find chat element (Shopify injects these dynamically)
    function findChatElement() {
      return document.getElementById('shopify-chat') || 
             document.getElementById('ShopifyChat') || 
             document.querySelector('inbox-online-store-chat');
    }

    // Update chat visibility based on scroll position
    function updateChatVisibility(chatElement) {
      if (!chatElement) return;

      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      const isScrolledPastThreshold = scrollY >= SCROLL_THRESHOLD;

      if (isScrolledPastThreshold) {
        chatElement.classList.remove(HIDDEN_CLASS);
        chatElement.classList.add(VISIBLE_CLASS);
      } else {
        chatElement.classList.remove(VISIBLE_CLASS);
        chatElement.classList.add(HIDDEN_CLASS);
      }
    }

    // Setup scroll listener
    function setupScrollListener(chatElement) {
      // Check initial scroll position (in case page loads already scrolled)
      updateChatVisibility(chatElement);

      // Listen to scroll events (throttled with requestAnimationFrame)
      let ticking = false;
      window.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            updateChatVisibility(chatElement);
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    }

    // Try to find chat element immediately
    let chatElement = findChatElement();
    
    if (chatElement) {
      setupScrollListener(chatElement);
    } else {
      // Chat not found yet, poll for it (simplified - no MutationObserver)
      let attempts = 0;
      const maxAttempts = 50; // 5 seconds max (50 * 100ms)
      const pollInterval = setInterval(() => {
        attempts++;
        chatElement = findChatElement();
        if (chatElement) {
          clearInterval(pollInterval);
          setupScrollListener(chatElement);
        } else if (attempts >= maxAttempts) {
          clearInterval(pollInterval);
          // Chat not found after max attempts, exit silently
        }
      }, 100);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }
})();
